import { Environment } from 'core/models/environment';
import React, { useState } from 'react';
import { createDropdownList } from 'components/views/atoms/DropdownList';
import styled from '@emotion/styled';
import { ignore } from 'utility/ignore';
import { fontFamily } from 'components/views/default';

const Item = styled.div({
    fontSize: '14px',
    fontFamily,
    padding: '10px',
});

const EnvironmentDropdownList = createDropdownList<Environment>(environment => <Item>{environment.name}</Item>);

const Title = styled.div({
    color: 'white',
    fontSize: '14px',
    fontFamily,
    padding: '10px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

const EnvironmentName = styled.span({
    fontSize: '20px',
    marginLeft: '0.3em',
});

export type EnvironmentSelectorProps = {
    environments: Environment[];
    selected: Environment | null;
    onSelect: (environment: Environment) => void;
};

export const EnvironmentSelector = (props: EnvironmentSelectorProps) => {
    const [listVisible, setListVisible] = useState<boolean>(false);
    ignore(listVisible);
    ignore(setListVisible);

    function onSelect(environments: Environment) {
        if (environments.id === '') return;
        props.onSelect(environments);
    }

    const values = props.environments.length > 0
        ? props.environments
        : [{ id: '', name: '(no environment)' }]
        ;

    return (
        <React.Fragment>
            <EnvironmentDropdownList values={values} direction={'DOWN'} onSelect={onSelect}>
                {
                    props.selected
                        ? <Title>
                            <span>ENVIRONMENT:</span>
                            <EnvironmentName>{props.selected.name}</EnvironmentName>
                        </Title>
                        :
                        props.environments.length > 0
                            ? <Title>
                                <EnvironmentName>please select environment</EnvironmentName>
                            </Title>
                            : <Title>
                                <EnvironmentName>no environment</EnvironmentName>
                            </Title>
                }
            </EnvironmentDropdownList>
        </React.Fragment>
    );
};
